<template>
  <div class="page-product">
    <!-- 返回 -->
    <div class="back-wrap" v-if="!isDshApp" :style="{ background: `rgba(255, 255, 255, ${BackWrapAlpha}` }">
      <img
        class="img-back"
        :src="BackWrapAlpha === 1 ? backDefaultIcon : backIcon"
        @click="handleClickBack()"
      />
      <span v-show="BackWrapAlpha === 1">商品详情</span>
    </div>
    <!-- 轮播图swiper -->
    <div class="swiper-banner" :style="{ height: `${bannerHeight}px` }">
      <swiper
        ref="bannerSwiper"
        :options="bannerSwiperOptions"
        class="swiper-wrapper"
        v-if="goodsData.smallPicUrl.length > 0"
      >
        <swiper-slide v-for="(item, index) in goodsData.smallPicUrl" :key="index">
          <div
            class="banner-img"
            :style="{ backgroundImage: `url(${formatHttpImg(item)})` }"
            @click="handleClickPreviewBanner(index)"
          ></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="info-wrap">
      <div class="coupon-marketPrice">
        <span>券后价</span>
        <span class="unit">¥</span>
        <span class="money">{{ formatStrAmount(goodsData.buyPrice) }}</span>
        <!-- 收益 -->
        <div class="earnings-wrap">
          <!-- 推广收益 -->
          <span
            class="tag-shareMoney"
            v-if="goodsData.sharePrice > 0"
          >推广收益:¥{{ goodsData.sharePrice }}</span>
          <!-- 金豆奖励 -->
          <span class="bean-num" v-if="goodsData.goldenBeans > 0">+{{ goodsData.goldenBeans }}</span>
          <img class="bean-img" :src="beanIcon" v-if="goodsData.goldenBeans > 0" />
        </div>
      </div>
      <div class="sale-wrap">
        <span
          class="original-price"
        >{{ goodsData.source }}价 ¥{{ formatStrAmount(goodsData.marketPrice) }}</span>
        <span class="sale-count" v-if="goodsData.hasOwnProperty('salesVolume')">已售{{ goodsData.salesVolume }}</span>
      </div>
      <div class="goods-title">
        <span
          :class="`source-tag ${goodsData.source === '淘宝' ? 'taobao' : 'tmall'}`"
        >{{ goodsData.source }}</span>
        {{ goodsData.title }}
      </div>
    </div>
    <div class="shop-wrap" v-if="seller">
      <!-- 店铺信息 -->
      <div class="shop-info">
        <img class="shop-avator" :src="(seller && seller.shopIcon) || defaultShopLogoIcon" />
        <span class="shop-name">{{ seller && seller.shopName }}</span>
        <span class="btn-look" @click="handleClickIntoShop()">进入店铺</span>
        <img class="ic-into" :src="inToIcon" @click="handleClickIntoShop()" />
      </div>
      <!-- 店铺评价信息 -->
      <div class="shop-evaluate-wrap" v-if="seller && seller.evaluates">
        <div class="evaluate-item" v-for="serviceItem in seller.evaluates">
          <span class="evaluate-title">{{ serviceItem.title }}</span>
          <span
            class="evaluate-score"
            :class="getEvaluateLevel(serviceItem.levelText)"
          >{{ serviceItem.score }}</span>
          <span
            class="evaluate-level"
            :class="getEvaluateLevel(serviceItem.levelText)"
          >{{ serviceItem.levelText }}</span>
        </div>
      </div>
    </div>
    <!-- 商品详情图片列表 -->
    <div class="desc-wrap">
      <div class="desc-head" @click="handleClickLookDetail()">
        查看宝贝详情
        <img class="ic-right" :src="showGoodsDetail ? downIcon : upIcon" />
      </div>
      <div class="imgList-wrap" v-show="showGoodsDetail">
        <img class="img-item" :src="formatHttpImg(imgItem)" v-for="imgItem in imgList" />
      </div>
    </div>
    <div class="nav-bar">
      <div class="nav-item" @click="handleClickHome()">
        <img class="img-home" :src="homeIcon" />
        <div>首页</div>
      </div>
      <div class="nav-item" @click="handleClickMark()" v-if="!isFromSearch && channel === 'tbk'">
        <img class="img-home" :src="goodsData.isCollection ? markedIcon : markIcon" />
        <div>收藏</div>
      </div>
      <div class="nav-option share" @click="handleClickShare()">
        <img class="icon-share" :src="shareIcon" />分享
      </div>
      <div class="nav-option buy" v-if="goodsData.couponAmount && goodsData.couponAmount > 0" @click="handleClickCoupon()">
        <img class="icon-coupon" :src="couponIcon" />
        领券 ¥{{ goodsData.couponAmount }}
      </div>
      <div class="nav-option buy" v-else @click="handleClickBuy()">立即购买</div>
    </div>

    <md-image-viewer
      v-model="showPreviewImg"
      :list="previewImgList"
      :has-dots="true"
      :initial-index="previewImgIndex"
    ></md-image-viewer>
  </div>
</template>

<script>
import LocalStore from '@/utils/localStore'
import Consts from '@/common/consts'
import LoginService from '@/services/login'
import Cookie from '@/utils/cookie'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { ImageViewer, Toast } from 'mand-mobile'
import { mapGetters } from 'vuex'
import _AP from '@/utils/ap'
import { isWeiXin, isDshApp } from '@/utils/help'
import wxJsSdk from '@/utils/wxJsSdk'
export default {
  name: 'product',
  components: {
    swiper,
    swiperSlide,
    [ImageViewer.name]: ImageViewer,
  },
  data() {
    return {
      isDshApp: isDshApp(),
      channel: '',
      goodsId: '',
      isFromSearch: false, // 来自于搜索页面
      goodsData: {
        smallPicUrl: [],
      },
      shareUrl: '', // 分享的链接
      isUploadSearchGoods: false, // 是否已上传搜索的产品
      imgList: [],
      seller: null,
      BackWrapAlpha: 0,
      backIcon: require('../assets/ic_back.png'),
      backDefaultIcon: require('../assets/ic_back_default.png'),
      homeIcon: require('../assets/ic_home.png'),
      markIcon: require('../assets/ic_mark_default.png'),
      markedIcon: require('../assets/ic_mark_on.png'),
      shareIcon: require('../assets/ic_share.png'),
      couponIcon: require('../assets/ic_coupon.png'),
      inToIcon: require('../assets/ic_into.png'),
      downIcon: require('../assets/ic_down.png'),
      upIcon: require('../assets/ic_up.png'),
      beanIcon: require('../assets/images/icon_bean.png'),
      defaultShopLogoIcon: require('../assets/ic_shop_logo.png'),
      showGoodsDetail: true,
      showPreviewImg: false,
      previewImgList: [],
      previewImgIndex: 0, // 预览图片的索引
      bannerHeight: 0, // 轮播图高度
      bannerSwiperOptions: {
        // 轮播图swiper
        direction: 'horizontal',
        loop: true,
        notNextTick: true,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        on: {
          click: function() {
            // 点击事件
          },
          slideChange: function() {
            // 切换slide
          },
        },
      },
    }
  },
  computed: {
    ...mapGetters(['token']),
  },
  created() {
    this.goodsId = `${this.$route.query.goodsId}`
    this.channel = this.$route.query.channel || 'tbk'
    this.initElementWidth()
    this.fetchRebateGoodsDetail()
    if (this.channel === 'tbk') {
      this.fetchTbGoodsDetail()
      this.fetchTbGoodsDesc()
    }
  },
  mounted() {
    this.addScroll()
  },
  destroyed() {
    this.removeScroll()
  },
  methods: {
    addScroll() {
      window.addEventListener('scroll', this.handleScroll, true)
    },
    removeScroll() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动高度
      if (scrollTop < 300) {
        this.BackWrapAlpha = scrollTop / 300.0
      } else {
        this.BackWrapAlpha = 1
      }
    },
    /**
     * 初始化轮播图的高度
     */
    initElementWidth() {
      let winW = window.innerWidth || document.body.clientWidth // 屏幕宽度
      this.bannerHeight = winW > 640 ? 640 : winW
    },
    /**
     * 点击预览轮播图图片
     */
    handleClickPreviewBanner(index) {
      this.previewImgIndex = index
      this.showPreviewImg = true
    },
    /**
     * 返利商品详情
     */
    fetchRebateGoodsDetail() {
      this.isFromSearch = this.$route.query.from && this.$route.query.from === 'search'
      if (this.isFromSearch) {
        // 来源于搜索页面,则直接从本地取商品详情数据
        this.goodsData = LocalStore.get(Consts.STORE_SEARCH_GOODS_DATA)
        this.previewImgList = this.goodsData.smallPicUrl
        this.initWxShare() // 初始化微信分享
      } else {
        let promise
        if (this.$route.query.from_search && `${this.$route.query.from_search}` === '1') {
          // 点击搜索的商品分享后的链接
          promise = this.$http.tbk.querySearchGoodsDetail(this.goodsId)
        } else {
          promise = this.$http[this.channel].goodsDetail(this.goodsId)
        }
        promise.then(res => {
          this.goodsData = res.data
          this.previewImgList = this.goodsData.smallPicUrl
          if (this.channel !== 'tbk') {
            this.imgList = (this.goodsData.detailPicUrl && this.goodsData.detailPicUrl.length > 0) ? this.goodsData.detailPicUrl: this.goodsData.smallPicUrl
          }
          this.initWxShare() // 初始化微信分享
        })
      }
    },
    /**
     * 微信分享
     */
    initWxShare() {
      const pageUrl = `${location.origin}/product/detail?goodsId=${this.goodsId}&channel=${this.channel}`
      const unionID = Cookie.get(Consts.COOKIE_USER_UNIONID)
      const prefix = unionID ? `${pageUrl}&unionID=dsh_${unionID}` : pageUrl
      this.shareUrl = `${prefix}&from_channel=h5${this.isFromSearch ? '&from_search=1' : ''}`
      console.log('分享链接', this.shareUrl)
      if (this.isFromSearch) {
        // 保存商品详情(搜索之后分享)
        this.$http.tbk.saveSearchGoodsDetail(JSON.stringify(this.goodsData)).then(res => {
          this.isUploadSearchGoods = true
        })
      }
      let _self = this
      wxJsSdk.config(function() {
        wxJsSdk.ready({
          title: `【DSHUI领券专区】`,
          // title: `【券后价 ¥${_self.formatStrAmount(_self.goodsData.buyPrice)}】`,
          desc: _self.goodsData.title,
          imgUrl: _self.goodsData.smallPicUrl[0],
          link: _self.shareUrl,
        })
      })
    },
    /**
     * 获取淘宝商品详情
     */
    fetchTbGoodsDetail() {
      this.$http.tbk.tbGoodsDetail(this.goodsId).then(res => {
        this.seller = res.seller
      })
    },
    /**
     * 获取淘宝商品详情--详情图片列表
     */
    fetchTbGoodsDesc() {
      this.$http.tbk.tbGoodsDesc(this.goodsId).then(res => {
        let imgList = []
        for (let item of res.wdescContent.pages) {
          if (item.indexOf('.jpg</img>') > -1) {
            imgList.push(item.substring(item.indexOf('//'), item.lastIndexOf('.jpg') + 4))
          }
          if (item.indexOf('.png</img>') > -1) {
            imgList.push(item.substring(item.indexOf('//'), item.lastIndexOf('.png') + 4))
          }
        }
        this.imgList = imgList
      })
    },
    /**
     * 获取评价等级
     */
    getEvaluateLevel(levelText) {
      if (levelText === '低') {
        return 'level1'
      } else if (levelText === '平') {
        return 'level2'
      } else if (levelText === '高') {
        return 'level3'
      }
      return 'level3'
    },

    /**
     * 获取店铺地址
     */
    getShopUrl(taoShopUrl) {
      if (taoShopUrl) {
        if (taoShopUrl.indexOf('http://') > -1 || taoShopUrl.indexOf('https://') > -1) {
          return taoShopUrl
        } else {
          return `https:${taoShopUrl}`
        }
      }
      return ''
    },

    /**
     * 点击进入店铺
     */
    handleClickIntoShop() {
      if (this.seller.taoShopUrl) {
        if (this.token) {
          LoginService.checkBindTb(isBind => {
            if (isBind) {
              if (isWeiXin()) {
                _AP.redirect(`https://pub.${Consts.WAP_HOST}/wx_jump_taobao.htm`, this.getShopUrl(this.seller.taoShopUrl))
              } else if (isDshApp()) {
                window.location.href = this.getShopUrl(this.seller.taoShopUrl)
              } else {
                window.location.href = this.getShopUrl(this.seller.taoShopUrl)
              }
            }
          })
        } else {
          this.handleClickLogin()
        }
      }
    },
    /**
     * 点击收藏
     */
    handleClickMark() {
      if (this.token) {
        let promise = this.goodsData.isCollection ? this.$http.tbk.unmarkProduct(this.goodsId) : this.$http.tbk.markProduct(this.goodsId)
        promise.then(res => {
          this.goodsData.isCollection = !this.goodsData.isCollection
          Toast.info(this.goodsData.isCollection ? '收藏成功' : '取消收藏', 800)
        })
      } else {
        this.handleClickLogin()
      }
    },
    /**
     * 点击分享
     */
    handleClickShare() {
      if (this.token) {
        LocalStore.set(Consts.STORE_SHARE_PRODUCT, this.goodsData)
        if (this.isFromSearch && !this.isUploadSearchGoods) {
          // 保存商品详情(搜索之后分享)
          Toast.loading('正在生成分享数据...')
          this.$http.tbk
            .saveSearchGoodsDetail(JSON.stringify(this.goodsData))
            .then(res => {
              Toast.hide()
              this.$router.push({
                name: 'productShare',
                query: { channel: this.channel, goodsId: this.goodsId, productUrl: encodeURIComponent(this.shareUrl) },
              })
            })
            .catch(() => {
              Toast.info('获取分享数据失败, 请重试')
            })
        } else {
          let routeQuery = { channel: this.channel, goodsId: this.goodsId, productUrl: encodeURIComponent(this.shareUrl) }
          if (this.channel === 'jd') {
            routeQuery.materialUrl = encodeURIComponent(this.goodsData.materialUrl)
            routeQuery.couponUrl = encodeURIComponent(this.goodsData.couponUrl)
          }
          this.$router.push({
            name: 'productShare',
            query: routeQuery,
          })
        }
      } else {
        this.handleClickLogin()
      }
    },
    /**
     * 点击购买
     */
    handleClickBuy() {
      if (this.token) {
        if (this.channel === 'tbk') {
          LoginService.checkBindTb(isBind => {
            if (isBind) {
              if (isWeiXin()) {
                _AP.redirect(`https://pub.${Consts.WAP_HOST}/wx_jump_taobao.htm`, this.goodsData.buyUrl)
              } else if (isDshApp()) {
                window.location.href = this.goodsData.buyUrl
              } else {
                window.location.href = this.goodsData.buyUrl
              }
            }
          })
        } else {
          this.fetchGoodsDetailBuyUrl('buy', url => {
            if (isDshApp()) {
              window.location.href = url
            } else {
              window.location.href = url
            }
          })
        }
      } else {
        this.handleClickLogin()
      }
    },
    /**
     * 点击领取优惠券
     */
    handleClickCoupon() {
      if (this.token) {
        if (this.channel === 'tbk') {
          LoginService.checkBindTb(isBind => {
            if (isBind) {
              if (isWeiXin()) {
                _AP.redirect(`https://pub.${Consts.WAP_HOST}/wx_jump_taobao.htm`, this.goodsData.couponClickUrl)
              } else if (isDshApp()) {
                window.location.href = this.goodsData.couponClickUrl
              } else {
                window.location.href = this.goodsData.couponClickUrl
              }
            }
          })
        } else {
          this.fetchGoodsDetailBuyUrl('buy', url => {
            if (isDshApp()) {
              window.location.href = url
            } else {
              window.location.href = url
            }
          })
        }
      } else {
        this.handleClickLogin()
      }
    },
    /**
     * 查询 拼多多/京东/唯品会 商品购买url
     */
    fetchGoodsDetailBuyUrl(type, callbackFunc) {
      let promise
      if (this.channel === 'pdd' || this.channel === 'vph') {
        promise = this.$http[this.channel].goodsDetailBuyUrl(this.goodsId, type)
      } else if (this.channel === 'jd') {
        promise = this.$http[this.channel].goodsDetailBuyUrl(this.goodsData.materialUrl, this.goodsData.couponUrl, type)
      }
      if (promise) {
        promise.then(res => {
          callbackFunc(res.data)
        })
      }
    },
    /**
     * 点击查看商品详情
     */
    handleClickLookDetail() {
      this.showGoodsDetail = !this.showGoodsDetail
    },
    /**
     * 去登录
     */
    handleClickLogin() {
      this.$router.push({ name: 'login' })
    },
    /**
     * 点击返回上一页
     */
    handleClickBack() {
      this.$router.go(-1)
    },
    /**
     * 点击回到首页
     */
    handleClickHome() {
      const homeRouteName = {
        tbk: 'home',
        pdd: 'pddHome',
        jd: 'jdHome',
        vph: 'vphHome',
      }
      const routeName = homeRouteName[this.channel] || 'home'
      this.$router.push({ name: routeName })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-product {
  position: relative;
  overflow: hidden;
  min-height: 100%;
  padding-bottom: 1rem;
  background: #f7f7f7;
  .back-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 0 20px;
    height: 88px;
    display: flex;
    align-items: center;
    background: #fff;
    z-index: 2;
    justify-content: center;
    font-weight: bold;
    .img-back {
      position: absolute;
      left: 20px;
      top: 16px;
      height: 56px;
    }
  }
  .swiper-banner {
    position: relative;
    width: 100%;
    top: 0;
    .banner-img {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      background: no-repeat 50%;
      background-size: cover;
    }
    .swiper-pagination-fraction {
      position: absolute;
      width: 72px;
      bottom: 22px;
      left: 85%;
      z-index: 100;
      color: #ccc;
      padding: 0 10px;
      height: 35px;
      background: rgba(0, 0, 0, 0.3047);
      border-radius: 8px;
      border: 2px solid hsla(0, 0%, 100%, 0.3047);
      text-align: center;
      font-size: 24px;
      font-weight: 800;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .info-wrap {
    background: #fff;
    padding: 24px;
  }
  .coupon-marketPrice {
    // 券后价
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #f42f19;
    font-size: 30px;
    .unit {
      display: inline-block;
      margin-left: 12px;
    }
    .money {
      font-size: 48px;
    }
    .earnings-wrap {
      margin-left: auto;
      display: flex;
      align-items: center;
      .tag-shareMoney {
        // 推广收益
        display: inline-block;
        height: 0.34rem;
        line-height: 0.34rem;
        padding: 0 0.1rem;
        text-align: center;
        border-radius: 0.04rem;
        font-size: 0.24rem;
        background: rgb(255, 234, 234);
        color: #f42f19;
        font-weight: 500;
      }
      .bean-num {
        padding-right: 0.04rem;
        padding-left: 0.12rem;
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #333;
      }
      .bean-img {
        display: inline-block;
        width: 0.25rem;
        height: 0.25rem;
        vertical-align: middle;
      }
    }
  }
  .sale-wrap {
    margin-top: 12px;
    display: flex;
    align-items: center;
    font-size: 24px;
    .original-price {
      // 原价
      color: #b3b3b3;
      text-decoration: line-through;
    }
    .sale-count {
      // 销量
      margin-left: auto;
      color: #999;
    }
  }
  .goods-title {
    // 产品名称
    line-height: 40px;
    margin: 24px 0;
    font-size: 28px;
    color: #333;
    font-weight: 600;
    user-select: text !important;
    .source-tag {
      display: inline-block;
      padding: 0.02rem 0.06rem;
      font-size: 0.2rem;
      margin-right: 0.04rem;
      line-height: 0.24rem;
      box-sizing: border-box;
      &.tmall {
        // 天猫
        border: 0.01rem solid #ff0036;
        color: #ff0036;
      }
      &.taobao {
        border: 0.01rem solid #fe9320;
        color: #fe9320;
      }
    }
  }
  .shop-wrap {
    margin-top: 16px;
    background: #fff;
    overflow: hidden;
    padding: 12px 24px;
    .shop-info {
      display: flex;
      align-items: center;
      .shop-avator {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        margin-right: 20px;
      }
      .shop-name {
        font-size: 30px;
        color: #333333;
        &:active {
          color: #d3d3d3;
        }
      }
      .btn-look {
        margin-left: auto;
        margin-right: 18px;
        color: #454545;
        font-size: 24px;
      }
      .ic-into {
        display: inline-block;
        height: 20px;
        vertical-align: middle;
      }
    }
    .shop-evaluate-wrap {
      display: flex;
      align-items: center;
      height: 60px;
      .evaluate-item {
        flex: 1;
        &:nth-child(1) {
          text-align: left;
        }
        &:nth-child(2) {
          text-align: center;
        }
        &:nth-child(3) {
          text-align: right;
        }
        .evaluate-title {
          color: #969696;
          font-size: 24px;
        }
        .evaluate-score {
          color: #f42f19;
          font-size: 24px;
          padding: 0 4px;
          &.level1 {
            // 低
            color: #5ba056;
          }
          &.level2 {
            // 平
            color: #969696;
          }
          &.level3 {
            // 高
            color: #f42f19;
          }
        }
        .evaluate-level {
          color: #f42f19;
          font-size: 20px;
          padding: 0 4px;
          &.level1 {
            // 低
            background: #5ba056;
            color: #fff;
          }
          &.level2 {
            // 平
            background: #f1f1f1;
            color: #969696;
          }
          &.level3 {
            // 高
            background: #f42f19;
            color: #ffffff;
          }
        }
      }
    }
  }
  .desc-wrap {
    // 商品详情
    margin-top: 16px;
    background: #fff;
    .desc-head {
      display: flex;
      align-items: center;
      height: 70px;
      padding: 0 24px;
      font-size: 30px;
      .ic-right {
        margin-left: auto;
        height: 30px;
      }
    }
  }
  .imgList-wrap {
    .img-item {
      width: 100%;
      vertical-align: middle;
    }
  }
  .nav-bar {
    // 底部导航
    position: fixed;
    display: flex;
    align-items: center;
    z-index: 999;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1rem;
    background: #fff;
    .nav-item {
      padding: 0 0.3rem;
      color: #969696;
      font-size: 0.2rem;
      text-align: center;
      .img-home {
        height: 0.6rem;
      }
      &:active {
        opacity: 0.3;
      }
    }
    .nav-option {
      display: flex;
      align-items: center;
      color: #fff;
      height: 0.84rem;
      justify-content: center;
      &.share {
        margin-left: auto;
        margin-right: 0;
        padding: 0 0.4rem;
        white-space: nowrap;
        border-top-left-radius: 0.84rem;
        border-bottom-left-radius: 0.84rem;
        background: linear-gradient(to right, #ffb643, #fe9320);
      }
      &.buy {
        margin-right: 0.4rem;
        min-width: 2.8rem;
        border-top-right-radius: 0.84rem;
        border-bottom-right-radius: 0.84rem;
        // min-width: 400px;
        // border-radius: 84px;
        background: linear-gradient(to right, #ff5c64, #fe2b2b);
        font-weight: 500;
      }
      &:active {
        opacity: 0.3;
      }
      .icon-share,
      .icon-coupon {
        height: 50px;
        margin-right: 0.1rem;
      }
    }
  }
}
</style>
